<template>
	<az-container>
		<az-container class="baixar-container">
			<v-row>
				<v-col cols="12">
					<div class="mensagem">
						<span class="box-aviso">
							<v-icon color="primary" class="mr-5">mdi-information</v-icon>
							Caso o download não tenha sido iniciado, clique para baixar.
						</span>
						<v-btn color="primary" data-testid="baixar-btn" large @click="baixarRelatorioControleAdesoes">
							Baixar
						</v-btn>
					</div>
				</v-col>
			</v-row>
		</az-container>
	</az-container>
</template>

<script>
import { actionTypes } from '@/core/constants'

export default {
	data() {
		return {
			idDocumento: this.$route.params.idDocumento,
		}
	},
	async mounted() {
		await this.baixarRelatorioControleAdesoes()
	},
	methods: {
		async baixarRelatorioControleAdesoes() {
			await this.$store.dispatch(actionTypes.RELATORIOS.CONTROLE_ADESOES.BAIXAR_RELATORIO, this.idDocumento)
		},
	},
}
</script>

<style scoped lang="stylus">
.baixar-container
	margin 20px !important

.mensagem
	display flex
	flex-direction column
	align-items center
	padding 30px
	gap 30px

	.titulo
		font-weight bold
		color var(--v-primary-base)
		font-size 20px

	.box-aviso
		color var(--v-primary-base)
		font-weight bold
		display flex
		text-align center
		justify-content center
		flex-direction row
		align-items center
		align-content center
		width 100%
</style>
